import React from "react";

import { SUPPLIER_URL } from "../../index";
import { LINKED_BY } from "./helpers";

const MUTED = "rgba(0,0,0,0.45)";

/** A line's linked product: title + SKU linking to the product page, and how it was linked. `product: null` with a productId = the product is gone. */
const LinkedProduct = ({ line }) => {
    if (!line.productId) return <span style={{ color: MUTED }}>Unlinked</span>;
    const how = <span style={{ color: MUTED, fontSize: 12 }}>{LINKED_BY[line.linkedBy] || ""}</span>;
    if (!line.product) return <span>Product not found <span style={{ color: MUTED, fontSize: 12 }}>{`${line.productId}`}</span> {how}</span>;
    const { _id, title, sku } = line.product;
    return (
        <span>
            <a target={_id} href={`${SUPPLIER_URL}/products/${_id}`}>{title}</a>
            {sku && <span style={{ color: MUTED, fontSize: 12 }}> {sku}</span>} {how}
        </span>
    );
};

export default LinkedProduct;



// WEBPACK FOOTER //
// ./src/components/supplier-price-list/linked-product.js